import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const CALENDLY_URL = "https://calendly.com/romain-trallero/diagnostic-transition-digitale-60min";

const faqCategories = [
  {
    title: 'Fonctionnement du service',
    items: [
      {
        question: 'Comment fonctionne BatiAssist ?',
        answer: 'BatiAssist met à ta disposition une assistante à mi-temps ou plein temps pour ton entreprise, ainsi qu\'une équipe digitale composée de 7 agents IA spécialisés. Ton assistante supervise les agents et coordonne toutes les actions pour ton entreprise.',
      },
      {
        question: 'Que fait concrètement l\'assistante dédiée ?',
        answer: 'Ton assistante peut notamment : gérer tes emails, organiser ton agenda, répondre à certaines demandes clients, préparer des réponses ou documents, suivre les tâches administratives, superviser les assistants digitaux et organiser les informations pour toi. Elle agit comme une assistante de direction pour ton entreprise.',
      },
      {
        question: 'Combien d\'heures travaille l\'assistante ?',
        answer: 'L\'assistante est disponible environ 40 heures par semaine pour ton entreprise.',
      },
      {
        question: 'Comment communiquer avec mon assistante ?',
        answer: 'La communication peut se faire via WhatsApp, par email ou via des outils collaboratifs. L\'objectif est de garder des échanges simples et rapides.',
      },
      {
        question: 'Est-ce que l\'assistante comprend mon métier ?',
        answer: 'L\'assistante est formée pour travailler avec des entrepreneurs et des artisans. Elle apprend progressivement ton organisation et tes priorités afin d\'être de plus en plus efficace.',
      },
    ],
  },
  {
    title: 'Équipe digitale',
    items: [
      {
        question: 'Qu\'est-ce que l\'équipe digitale ?',
        answer: 'En plus de l\'assistante dédiée, tu bénéficies d\'une équipe digitale composée de 7 agents IA spécialisés. Chaque agent est conçu pour effectuer une tâche précise.',
      },
      {
        question: 'Quels sont les rôles des assistants digitaux ?',
        answer: 'Les assistants digitaux peuvent notamment : répondre aux messages, gérer certaines interactions clients, publier du contenu, analyser ta visibilité sur internet, rédiger des articles, automatiser certaines tâches et gérer un standard téléphonique intelligent.',
      },
      {
        question: 'Est-ce que les assistants digitaux travaillent en permanence ?',
        answer: 'Certains outils peuvent fonctionner en continu, ce qui permet d\'automatiser certaines actions 24h/24.',
      },
      {
        question: 'Est-ce que l\'intelligence artificielle remplace l\'humain ?',
        answer: 'Non. L\'intelligence artificielle est utilisée pour assister l\'assistante dédiée. L\'assistante supervise toujours le travail réalisé.',
      },
    ],
  },
  {
    title: 'Standard téléphonique',
    items: [
      {
        question: 'Est-ce que le service peut gérer mes appels téléphoniques ?',
        answer: 'Oui. Un système de standard téléphonique intelligent peut être mis en place pour répondre aux appels entrants, filtrer certaines demandes, orienter les appels et transmettre les informations importantes.',
      },
      {
        question: 'Est-ce que le standard peut aussi appeler des prospects ?',
        answer: 'Oui. Le standard peut également être utilisé pour effectuer certains appels sortants, notamment dans des campagnes de prospection ou de suivi.',
      },
      {
        question: 'Est-ce que je risque de manquer des appels ?',
        answer: 'Le système permet de réduire fortement les appels manqués et d\'améliorer la gestion des demandes clients.',
      },
    ],
  },
  {
    title: 'Machine à nouveaux clients',
    items: [
      {
        question: 'Qu\'est-ce que la machine à nouveaux clients ?',
        answer: 'Dans la formule avancée à 1499€/mois, une seconde assistante est dédiée à la recherche et à l\'interaction avec des prospects. L\'objectif est de mettre en place un système organisé pour identifier des prospects, créer des interactions, qualifier les contacts et générer des opportunités commerciales.',
      },
      {
        question: 'Comment fonctionne cette machine à nouveaux clients ?',
        answer: 'La seconde assistante peut notamment : rechercher des entreprises ou prospects ciblés, créer des interactions sur les réseaux professionnels, organiser certaines actions de prospection et qualifier les contacts.',
      },
      {
        question: 'Est-ce que cela permet vraiment de trouver des clients ?',
        answer: 'L\'objectif est d\'aider à créer des opportunités et à structurer la prospection. Les résultats peuvent varier selon l\'activité et l\'implication de l\'entreprise.',
      },
    ],
  },
  {
    title: 'Tarifs et engagement',
    items: [
      {
        question: 'Combien coûte le service ?',
        answer: 'Deux formules principales sont proposées : Formule Organisation à 949€/mois (1 assistante + équipe digitale) et Formule Croissance à 1499€/mois (2 assistantes + machine à nouveaux clients).',
      },
      {
        question: 'Y a-t-il des frais de mise en place ?',
        answer: 'Oui. Des frais de mise en place de 500€ sont appliqués. Ces frais permettent le recrutement de l\'assistante, la formation, la configuration des outils et le paramétrage des assistants digitaux.',
      },
      {
        question: 'Quand le service commence-t-il ?',
        answer: 'Après la validation de l\'inscription et la mise en place des outils. Une phase de préparation d\'environ 15 jours est généralement nécessaire.',
      },
      {
        question: 'Y a-t-il un engagement ?',
        answer: 'Non. Le service fonctionne sous forme d\'abonnement flexible sans engagement longue durée.',
      },
      {
        question: 'Pourquoi ne pas simplement recruter une assistante ?',
        answer: 'Recruter un salarié implique un salaire, des charges sociales, des obligations administratives et des risques juridiques. Un salarié administratif coûte minimum 3500€/mois avec les charges. BatiAssist permet d\'accéder à une organisation structurée sans ces contraintes.',
      },
    ],
  },
  {
    title: 'Confidentialité et démarrage',
    items: [
      {
        question: 'Mes données sont-elles protégées ?',
        answer: 'Oui. Les informations de ton entreprise sont traitées de manière confidentielle avec des protocoles de sécurité stricts.',
      },
      {
        question: 'Comment démarrer ?',
        answer: 'Il suffit de réserver un entretien afin d\'échanger sur ta situation et comprendre comment le service peut s\'adapter à ton activité.',
      },
    ],
  },
];

export default function FAQPage() {
  return (
    <div data-testid="faq-page">
      {/* Hero */}
      <section className="py-20 md:py-32 gradient-mesh">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-rm-text mb-6">
              Questions fréquentes
            </h1>
            <p className="text-lg md:text-xl text-rm-text-secondary mb-8">
              Tout ce que tu dois savoir sur BatiAssist, l'assistant, 
              l'équipe digitale et la machine à nouveaux clients.
            </p>
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              <Button className="bg-rm-secondary hover:bg-rm-secondary/90 text-white font-semibold rounded-full px-8 py-6 text-lg shadow-lg">
                Réserver un entretien
              </Button>
            </a>
          </motion.div>
        </div>
      </section>

      {/* FAQ Categories */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          {faqCategories.map((category, categoryIndex) => (
            <motion.div
              key={categoryIndex}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: categoryIndex * 0.1 }}
              className="mb-12"
            >
              <h2 className="text-2xl font-bold text-rm-text mb-6">
                {category.title}
              </h2>
              <Accordion type="single" collapsible className="space-y-3">
                {category.items.map((item, itemIndex) => (
                  <AccordionItem 
                    key={itemIndex}
                    value={`${categoryIndex}-${itemIndex}`}
                    className="bg-slate-50 rounded-xl border-0 px-6"
                  >
                    <AccordionTrigger className="text-left text-rm-text font-medium py-4 hover:no-underline">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-rm-text-secondary pb-4 leading-relaxed">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-rm-accent/10">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-5xl font-bold text-rm-text mb-6">
              Et si ton entreprise fonctionnait enfin différemment ?
            </h2>
            <p className="text-lg md:text-xl text-rm-text-secondary mb-8">
              Réserve un entretien pour découvrir comment BatiAssist peut t'aider 
              à organiser ton entreprise et gagner du temps.
            </p>
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              <Button className="bg-rm-secondary hover:bg-rm-secondary/90 text-white font-semibold rounded-full px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all group">
                Réserver un entretien avec Romain
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
